// src/api-config.js
let API_URL;
// API_URL = "http://localhost:8000"
API_URL = "https://api.biblioteca-invision.com/invision-api"

export { API_URL };
